
import { Component, Mixins, Prop } from 'vue-property-decorator';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';
import UserRightsMixin from '~/mixins/UserRightsMixin';

@Component
export default class RemoteFeatureEditionButtons extends Mixins(DarkThemeInfoMixin, UserRightsMixin) {
    @Prop({ default: false }) isEditable!: boolean;

    get isEditableValue() {
        return this.isEditable;
    }
    set isEditableValue(value: boolean) {
        this.$emit('update:isEditable', value);
    }

    updateFlag() {
        this.$emit('updateFlag');
    }
    clearEdition() {
        this.$emit('clearEdition');
    }

}
